<template>
  <div v-if="isLoadingStoreDetail == false">
    <v-card-text style="max-height: calc(100vh - 64px - 80px); overflow: auto">
      <v-form ref="form">
        <div
          style="
            display: flex;
            flex-direction: column;
            margin-top: 20px;
            padding-inline: 3vw;
            padding-block: 30px;
          "
        >
          <v-layout wrap>
            <v-flex xs12 sm6 class="pa-3">
              <div style="display: flex; justify-content: center">
                <img
                  :src="storeProfileImage"
                  :style="{
                    width: '400px',
                  }"
                  class="elevation-3"
                  style="border-radius: 6px"
                  alt="Cropped Image"
                  v-if="storeProfileImage && storeProfileImage != null"
                />
                <v-card
                  flat
                  :height="220.17 + 'px'"
                  :width="height * 1.3 + 'px'"
                  color="#e9e9e9"
                  class="text-xs-center"
                  style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border-radius: 6px;
                  "
                  v-else
                >
                  <v-card-text class="white--text">
                    <v-btn
                      icon
                      color="black"
                      @click="$refs.ProfileInput.click()"
                      ><v-icon color="white">add</v-icon></v-btn
                    >
                  </v-card-text></v-card
                >
              </div>
              <div style="margin-bottom: 20px"></div>
              <div class="text-xs-center">
                <input
                  style="display: none"
                  type="file"
                  @change="onProfileImageSelected"
                  ref="ProfileInput"
                  accept="image/*"
                />
                <v-btn
                  v-if="storeProfileImage && storeProfileImage != null"
                  color="black"
                  class="white--text"
                  @click="$refs.ProfileInput.click()"
                  ><v-icon size="14" color="white" class="mr-1">edit</v-icon>
                  Edit image</v-btn
                >
              </div>
            </v-flex>
            <v-flex xs12 sm6>
              <v-layout wrap>
                <v-flex>
                  <v-layout wrap>
                    <v-flex class="pa-3">
                      <p class="info-header" style="margin-bottom: 0px">
                        Store Type
                      </p>
                      <v-select
                        multiple
                        v-model="storeType"
                        :items="store_type"
                        item-text="store_type_name_th"
                        item-value="store_type_id"
                        menu-props="auto"
                        label="Select"
                        hide-details
                        single-line
                        required
                      >
                      </v-select>
                    </v-flex>
                    <v-flex class="pa-3">
                      <p class="info-header" style="margin-bottom: 0px">
                        Store Category
                      </p>
                      <v-select
                        multiple
                        v-model="storeCategories"
                        :items="store_category"
                        item-text="store_category_name_th"
                        item-value="store_category_id"
                        menu-props="auto"
                        label="Select"
                        hide-details
                        single-line
                        required
                      >
                      </v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex>
                  <v-layout wrap>
                    <v-flex class="pa-3">
                      <p class="info-header">Store Recommend</p>
                      <v-radio-group
                        row
                        v-model="storeRecommend"
                        color="#fddf00"
                      >
                        <v-radio
                          :label="`Yes`"
                          :value="1"
                          color="#fddf00"
                        ></v-radio>
                        <v-radio
                          :label="`No`"
                          :value="0"
                          color="#fddf00"
                        ></v-radio>
                      </v-radio-group>
                    </v-flex>

                    <v-flex class="pa-3">
                      <p class="info-header">Store Best Seller</p>
                      <v-radio-group row v-model="storeBestSeller">
                        <v-radio
                          :label="`Yes`"
                          :value="1"
                          color="#fddf00"
                        ></v-radio>
                        <v-radio
                          :label="`No`"
                          :value="0"
                          color="#fddf00"
                        ></v-radio>
                      </v-radio-group>
                    </v-flex> </v-layout
                ></v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-dialog v-model="collect_store_images_dialog" max-width="65vw">
            <v-card>
              <imageCropper
                :aspectRatio="480 / 320"
                :imageName="selectedFile.store_img_name"
                :imgSrc="storeImageTemp"
                :height="300"
                @close="collect_store_images_dialog = false"
                @setImageName="selectedFile.store_img_name = $event"
                @getCroped="getCollectCropped($event)"
                v-if="storeImageTemp != ''"
              ></imageCropper>
            </v-card>
          </v-dialog>
          <v-dialog v-model="store_images_dialog" max-width="65vw">
            <v-card>
              <imageCropper
                :aspectRatio="480 / 320"
                :imageName="selectedFile.store_img_name"
                :imgSrc="storeImageTemp"
                :height="300"
                @close="store_images_dialog = false"
                @setImageName="selectedFile.store_img_name = $event"
                @getCroped="getProfileCropped($event)"
                v-if="storeImageTemp != ''"
              ></imageCropper>
            </v-card>
          </v-dialog>

          <v-dialog v-model="deleteImgDialog" max-width="30vw">
            <v-card>
              <v-card-title class="headline yellow lighten-2" primary-title>
                Delete Image
              </v-card-title>

              <v-card-text style="font-size: 1.35rem; margin-block: 15px">
                Are you sure to permanent delete this image?
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red" flat @click="deleteImgDialog = false">
                  Cancel
                </v-btn>
                <v-btn color="primary" flat @click="deleteStoreImage">
                  Confirm
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-layout
            wrap
            style="margin-top: 20px; display: flex; align-items: center"
          >
            <v-flex xs12 sm6 class="pa-2">
              <v-text-field
                required
                v-model="storeNameTH"
                :rules="storeNameRules"
                label="Store Name (Thai)"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm6 class="pa-2">
              <v-text-field
                required
                v-model="storeNameEN"
                :rules="storeNameRules"
                label="Store Name (English)"
              >
              </v-text-field>
            </v-flex>

            <v-flex xs12 sm6 class="pa-2">
              <v-text-field
                required
                v-model="storeAddressTH"
                :rules="storeNameRules"
                label="Store Address TH"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm6 class="pa-2">
              <v-text-field
                required
                v-model="storeAddressEN"
                :rules="storeNameRules"
                label="Store Address EN"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm6 class="pa-2">
              <v-textarea
                v-model="storeDescriptionTH"
                required
                label="Store Description TH"
                counter="255"
                :rules="[
                  (v) => v.length <= 255 || 'Character must less than 256',
                ]"
              >
              </v-textarea>
            </v-flex>
            <v-flex xs12 sm6 class="pa-2">
              <v-textarea
                v-model="storeDescriptionEN"
                required
                label="Store Description EN"
                counter="255"
                :rules="[
                  (v) => v.length <= 255 || 'Character must less than 256',
                ]"
              >
              </v-textarea>
            </v-flex>
            <v-flex xs12 sm6 class="pa-2">
              <v-text-field
                v-model="storeTel"
                required
                :rules="storeTelRules"
                mask="###-###-####"
                label="Store Telephone Number"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm6 class="pa-2">
              <v-text-field
                v-model="storeEmail"
                required
                :rules="emailRules"
                label="Store Email"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm6 class="pa-2">
              <v-text-field
                label="Store Table Amount"
                v-model="storeTableAmount"
                @keypress="isNumberWithoutDot($event)"
                required
                :rules="storeTableAmountRules"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm6 class="pa-2">
              <v-text-field
                label="Store Commission (%)"
                v-model="storeCommission"
                @keypress="onlyDoubleNotNegative($event, storeCommission)"
                required
                :rules="storeCommissionRules"
                suffix="%"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm6 class="pa-2">
              <v-text-field
                label="Store Period Time (Minute)"
                v-model="storePeriodTime"
                @keypress="isNumberWithoutDot($event)"
                required
                type="number"
                :rules="storePeriodTimeRules"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm6 class="pa-2">
              <v-text-field
                label="Store Rating"
                v-model="storeRating"
                type="number"
                required
                :rules="[
                  (v) => (v >= 0 && v <= 5) || 'Rating must be between 0 - 5',
                ]"
              >
              </v-text-field>
            </v-flex>
          </v-layout>

          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: flex-end;
              padding-block: 10px;
              padding-inline: 20px;
            "
          >
            <p class="info-header">Upload Store Image</p>
            <div>
              <v-btn
                @click="$refs.LogoInput.click()"
                color="primary"
                style="color: black"
                ><v-icon class="mr-1" color="black">upload</v-icon> UPLOAD IMAGE
              </v-btn>
              <input
                style="display: none"
                type="file"
                @change="onCollectImageSelected"
                ref="LogoInput"
                accept="image/*"
              />
            </div>
          </div>

          <div style="padding-inline: 20px">
            <div
              style="
                width: 100%;
                display: flex;
                flex-direction: column;
                padding-top: 20px;
                padding-bottom: 30px;
                padding-inline: 20px;
                background-color: #fddf0016;
                border-radius: 10px;
                border: 2px dashed #80808054;
                min-height: 150px;
              "
            >
              <v-layout row wrap align-center justify-space-around>
                <v-flex md4 v-for="(image, index) in storeImage" :key="index">
                  <v-layout>
                    <v-flex
                      style="
                        display: flex;
                        justify-content: center;
                        margin-top: 20px;
                      "
                    >
                      <div
                        style="
                          width: 20vw;
                          height: 220.17px;
                          position: relative;
                        "
                      >
                        <v-btn
                          fab
                          dark
                          small
                          color="red"
                          style="position: absolute; top: 5px; right: 5px"
                          @click="openDeleteStoreImageIndex(index)"
                        >
                          <v-icon color="white">delete</v-icon>
                        </v-btn>
                        <img
                          :src="image.image_store"
                          :style="{
                            width: 20 + 'vw',
                            height: 220.17,
                            border: '5px dashed white',
                          }"
                          alt="Cropped Image"
                          v-if="image.image_store && image.image_store != null"
                        />
                        <v-card
                          :height="220.17 + 'px'"
                          :width="height * 1.3 + 'px'"
                          color="grey"
                          class="text-xs-center pt-3"
                          v-else
                        >
                          No image</v-card
                        >
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </div>
          </div>

          <v-layout
            wrap
            style="display: flex; align-items: center; margin-top: 40px"
          >
            <v-flex xs12 sm6 class="pa-2">
              <v-select
                v-model="storeProvince"
                :items="provinceData"
                item-text="province_name_th"
                item-value="province_id"
                menu-props="auto"
                label="Select Province"
                hide-details
                @change="getDistrict()"
              >
              </v-select>
            </v-flex>
            <v-flex xs12 sm6 class="pa-2">
              <v-select
                v-model="storeDistrict"
                :items="district"
                item-text="district_name_th"
                item-value="district_id"
                menu-props="auto"
                label="Select District"
                hide-details
                @change="getSubAndZip()"
                :disabled="storeProvince == '' ? true : false"
              >
              </v-select>
            </v-flex>

            <v-flex xs12 sm6 class="pa-2">
              <v-select
                v-model="storeSubDistrict"
                :items="sub_district"
                item-text="sub_district_name_th"
                item-value="sub_district_id"
                menu-props="auto"
                label="Select Sub-District"
                hide-details
                :disabled="storeDistrict == '' ? true : false"
              >
              </v-select>
            </v-flex>
            <v-flex xs12 sm6 class="pa-2">
              <v-select
                v-model="storeZipcode"
                :items="zipcode"
                item-text="zipcode_code"
                item-value="zipcode_id"
                menu-props="auto"
                label="Select Zipcode"
                hide-details
                :disabled="storeDistrict == '' ? true : false"
              >
              </v-select>
            </v-flex>
          </v-layout>
        </div>

        <div style="padding-inline: 3vw">
          <div
            style="
              margin-inline: 20px;
              background-color: #fddf0016;
              margin-top: 40px;
              padding-bottom: 20px;
            "
          >
            <p
              class="info-header"
              style="
                background-color: #fddf00;
                width: 100%;
                padding-inline: 10px;
                padding-block: 15px;
                font-size: 1.8rem;
              "
            >
              Store Location
            </p>
            <div
              style="
                display: flex;
                align-items: flex-start;
                padding-block: 10px;
                padding-inline: 20px;
              "
            >
              <v-layout>
                <v-flex>
                  <v-layout wrap>
                    <v-flex xs12 sm6 class="pa-2">
                      <v-text-field
                        required
                        v-model="storeLat"
                        v-on:keypress="onlyDoubleForLocation($event, storeLat)"
                        :rules="latRules"
                        label="Latitude"
                      >
                      </v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 class="pa-2">
                      <v-text-field
                        required
                        v-model="storeLng"
                        v-on:keypress="onlyDoubleForLocation($event, storeLng)"
                        :rules="lngRules"
                        label="Longitude"
                      >
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                  <div
                    style="
                      display: flex;
                      justify-content: flex-end;
                      margin-bottom: 20px;
                    "
                  >
                    <v-btn
                      @click="resetLocation"
                      color="black"
                      class="white--text"
                    >
                      Reset Location
                    </v-btn>
                    <v-btn @click="change++" color="black" class="white--text">
                      Edit Location
                    </v-btn>
                  </div>
                  <GoogleMap
                    :latitude="parseFloat(storeLat)"
                    :longitude="parseFloat(storeLng)"
                    :mapType="'latandlong'"
                    :zoom="15"
                    :draggable="true"
                    @draged="getDragLocation($event)"
                    :change="change"
                  >
                  </GoogleMap>
                </v-flex>
              </v-layout>
            </div>
          </div>
        </div>
      </v-form>
      <v-dialog v-model="error_dialog" persistent max-width="500">
        <v-card>
          <div
            style="
              background-color: #fddf00;
              height: 60px;
              display: flex;
              align-items: center;
              padding-left: 20px;
            "
          >
            <v-icon large style="margin-right: 10px" color="black"
              >warning</v-icon
            >
            <div style="font-size: 1.8rem">Warning</div>
          </div>
          <v-card-title class="headline" primary-title>{{
            error_text
          }}</v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" flat @click="error_dialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="failed_dialog" max-width="350">
        <v-card style="border-radius: 20px">
          <div
            style="
              display: flex;
              flex-direction: column;
              align-items: center;
              padding-block: 30px;
            "
          >
            <v-icon
              x-large
              style="margin-bottom: 10px; font-size: 70px"
              color="red"
              >close</v-icon
            >
            <div style="font-size: 1.8rem">Update Failed</div>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" flat @click="failed_dialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions style="height: 75px">
      <v-spacer></v-spacer>
      <v-btn
        @click="updateDineInStore"
        color="primary"
        style="min-width: 300px; width: 40vw"
        class="black--text"
        :loading="isUpdating"
      >
        <span style="font-weight: 600">Update</span>
      </v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
  </div>
  <div v-else style="overflow: hidden">
    <LottieAnimation
      width="100%"
      :height="700"
      path="img/icons/lottie/loading-dine-in.json"
    />
  </div>
</template>

<script>
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue"; // import lottie-vuejs
import GoogleMap from "@/components/Plugins/GoogleMap.vue";
import imageCropper from "@/components/Plugins/imageCropper.vue";
import imageUploader from "@/components/back-office/StoreManagement/ImageUploader.vue";
import { mapState } from "vuex";
export default {
  props: ["store_id", "dialog"],
  data: () => ({
    isUpdating: false,
    valid: false,
    store_data: "",
    change: 0,
    storeType: [],
    storeCategories: [],
    storeNameTH: "",
    storeNameEN: "",
    storeAddressTH: "",
    storeAddressEN: "",
    storeDescriptionTH: "",
    storeDescriptionEN: "",
    storeTel: "",
    storeEmail: "",
    storeProvince: "",
    storeDistrict: "",
    storeSubDistrict: "",
    storeZipcode: "",
    storeRecommend: 1,
    storeBestSeller: 1,
    height: 300,
    error_dialog: false,
    collect_store_images_dialog: false,
    store_images_dialog: false,
    success_dialog: false,
    failed_dialog: false,
    change_image: 0,
    storeImageTemp: "",
    error_text: "",
    selectedFile: {
      image_store: "",
      store_img_name: "",
    },
    storeProfileImage: "",
    storeImage: [],
    deleteImgDialog: false,
    deleteImageIndex: 0,
    storeStatus: false,
    storeLat: "",
    storeLng: "",
    removeStoreImage: [],
    storeTableAmount: "",
    storeCommission: "",
    store_type: [],
    store_category: [],
    store_package: [],
    storePeriodTime: "",
    storeRating: null,
    province: [],
    district: [],
    sub_district: [],
    zipcode: [],
    storeNameRules: [
      (v) => {
        if (v === "") {
          return "Store name is required";
        } else {
          return true;
        }
      },
    ],
    storeAddressRules: [
      (v) => {
        if (v === "") {
          return "Store address is required";
        } else {
          return true;
        }
      },
    ],
    storeTelRules: [
      (v) => {
        if (v === "") {
          return "Store telephone number is required";
        } else {
          return true;
        }
      },
      (v) => {
        if (v == "") {
          return "";
        }
        if (v.charAt(0) === "0") {
          if (v.length > 10) {
            return "Store telephone number is invalid.";
          } else if (v.length < 10) {
            return "Store telephone number must be 10 charecter length.";
          } else {
            return true;
          }
        } else {
          if (v.length > 9) {
            return "Store telephone number is invalid";
          } else if (v.length < 9) {
            return "Store telephone number must be 9 charecter length.";
          } else {
            return true;
          }
        }
      },
    ],
    emailRules: [
      (v) => {
        if (/.+@.+/.test(v)) {
          return true;
        } else if (v === "") {
          return true;
        } else {
          return "E-mail is invalid";
        }
      },
    ],
    storeTableAmountRules: [
      (v) => {
        if (v === "") {
          return "Store Table Amount is required";
        } else {
          return true;
        }
      },
    ],
    storePeriodTimeRules: [
      (v) => {
        if (v === "") {
          return "Store Period Time is required";
        } else {
          return true;
        }
      },
    ],
    storeCommissionRules: [
      (v) => {
        if (v === "") {
          return "Store Commission is required";
        } else {
          return true;
        }
      },
      (v) => {
        if (parseInt(v) > 100) {
          return "Store Commission must be between 0-100";
        } else {
          return true;
        }
      },
    ],
    latRules: [
      (v) => {
        const pattern = /^-?([0-9]?[0-9]?[0-9]?[0-9]|[0-9]0)\.{1}\d{1,100}$/;
        return pattern.test(v) || "Invalid";
      },
      (v) => {
        if (parseFloat(v) > 90 || parseFloat(v) < -90) {
          return "Store latitude must be between -90 and 90";
        } else {
          return true;
        }
      },
    ],
    lngRules: [
      (v) => {
        const pattern = /^-?([0-9]?[0-9]?[0-9]?[0-9]|[0-9]0)\.{1}\d{1,100}$/;
        return pattern.test(v) || "Invalid";
      },
      (v) => {
        if (parseFloat(v) > 180 || parseFloat(v) < -180) {
          return "Store latitude must be between -180 and 180";
        } else {
          return true;
        }
      },
    ],
    isLoadingStoreDetail: false,
    isLoadingStoreType: false,
    isLoadingStoreCategory: false,
  }),
  computed: {
    ...mapState({
      provinceData: (state) => state.fetchProvinceBack.provinceData,
      packageItems: (state) => state.fetchPackageBack.package_data,
    }),
  },
  watch: {
    dialog: async function () {
      if (this.dialog == true) {
        this.isLoadingStoreDetail = true;
        await this.getStoreData(this.store_id);
        this.isLoadingStoreDetail = false;
      }
    },
  },
  components: { GoogleMap, imageCropper, imageUploader, LottieAnimation },
  methods: {
    isNumberWithoutDot(evt) {
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (evt.keyCode == 110 || evt.keyCode == 190) {
      }
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      }
    },
    onlyDouble(e, cha) {
      let char = String.fromCharCode(e.keyCode);
      const count = (cha.match(/\./g) || []).length;
      if (count > 0) {
        if (/\d/.test(char)) return true;
        else e.preventDefault();
      }
    },
    onlyDoubleNotNegative(e, cha) {
      let char = String.fromCharCode(e.keyCode);
      const count = (cha.match(/\./g) || []).length;
      if (count > 0) {
        if (/\d/.test(char)) return true;
        else e.preventDefault();
      }
      const charCode = e.which ? e.which : e.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57 || charCode == 45)) {
        if (charCode != 46) e.preventDefault();
      }
    },
    onlyDoubleForLocation(e, cha) {
      let char = String.fromCharCode(e.keyCode);
      const count = (cha.match(/\./g) || []).length;
      const countDash = (cha.match(/\-/g) || []).length;
      if (count > 0) {
        if (/\d/.test(char)) return true;
        else e.preventDefault();
      }
      if (countDash > 0) {
        if (/\d/.test(char)) return true;
        else e.preventDefault();
      }
      const charCode = e.which ? e.which : e.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        if (charCode == 46 || charCode == 45) {
        } else {
          e.preventDefault();
        }
      }
    },
    getDragLocation(val) {
      this.storeLat = val.lat;
      this.storeLng = val.lng;
    },
    resetLocation() {
      this.storeLat = "7.880338324673776";
      this.storeLng = "98.39217356819148";
      this.change++;
    },
    getCollectCropped(image_value) {
      this.selectedFile.image_store = image_value;
      this.storeImage.push({
        image_store: this.selectedFile.image_store,
        store_img_name: this.selectedFile.store_img_name,
      });
      this.selectedFile = { image_store: "", store_img_name: "" };
      this.change_image = 1;
      this.storeImageTemp = "";
    },
    getProfileCropped(image_value) {
      this.storeProfileImage = image_value;
      this.selectedFile = { image_store: "", store_img_name: "" };
      this.change_image = 1;
      this.storeImageTemp = "";
    },
    openDeleteStoreImageIndex(index) {
      this.deleteImgDialog = true;
      this.deleteImageIndex = index;
    },
    onProfileImageSelected(event) {
      this.storeImageTemp = "";
      let file = event.target.files[0];
      this.selectedFile.store_img_name = file.name;
      let reader = new FileReader();
      reader.addEventListener("load", () => {
        this.storeImageTemp = reader.result;
        this.store_images_dialog = true;
      });
      reader.readAsDataURL(file);
      event.target.value = "";
    },
    onCollectImageSelected(event) {
      this.storeImageTemp = "";
      let file = event.target.files[0];
      this.selectedFile.store_img_name = file.name;
      let reader = new FileReader();
      reader.addEventListener("load", () => {
        this.storeImageTemp = reader.result;
        this.collect_store_images_dialog = true;
      });
      reader.readAsDataURL(file);
      event.target.value = "";
    },
    async updateDineInStore() {
      if (!this.$refs.form.validate()) return;
      if (this.storeProfileImage === "") {
        this.error_text = "Please upload store profile image.";
        this.error_dialog = true;
        return;
      }
      if (this.storeType.length == 0) {
        this.error_text = "Please select store type.";
        this.error_dialog = true;
        return;
      }

      if (this.storeCategories.length == 0) {
        this.error_text = "Please select store category.";
        this.error_dialog = true;
        return;
      }

      if (this.storeNameTH === "") {
        this.error_text = "Please enter store name (Thai).";
        this.error_dialog = true;
        return;
      }
      if (this.storeNameEN === "") {
        this.error_text = "Please enter store name (English).";
        this.error_dialog = true;
        return;
      }
      if (this.storeAddressTH === "") {
        this.error_text = "Please enter store address (Thai).";
        this.error_dialog = true;
        return;
      }
      if (this.storeAddressEN === "") {
        this.error_text = "Please enter store address (English).";
        this.error_dialog = true;
        return;
      }
      if (this.storeRecommend === "") {
        this.error_text = "Please enter store recommend.";
        this.error_dialog = true;
        return;
      }
      if (this.storeProvince === "") {
        this.error_text = "Please select store province.";
        this.error_dialog = true;
        return;
      }
      if (this.storeDistrict === "") {
        this.error_text = "Please select store district.";
        this.error_dialog = true;
        return;
      }
      if (this.storeSubDistrict === "") {
        this.error_text = "Please select store sub district.";
        this.error_dialog = true;
        return;
      }
      if (this.storeZipcode === "") {
        this.error_text = "Please select store zip code.";
        this.error_dialog = true;
        return;
      }
      if (this.storeLat === "") {
        this.error_text = "Please enter store latitude.";
        this.error_dialog = true;
        return;
      }
      if (parseFloat(this.storeLat) < -90 || parseFloat(this.storeLat) > 90) {
        this.error_text = "Store latitude is invalid value.";
        this.error_dialog = true;
        return;
      }
      if (this.storeLng === "") {
        this.error_text = "Please enter store longitude.";
        this.error_dialog = true;
        return;
      }
      if (parseFloat(this.storeLng) < -180 || parseFloat(this.storeLng) > 180) {
        this.error_text = "Store longitude is invalid value.";
        this.error_dialog = true;
        return;
      }
      if (this.storeTel === "") {
        this.error_text = "Please enter store telephone number.";
        this.error_dialog = true;
        return;
      }
      if (this.storeTableAmount === "") {
        this.error_text = "Please enter store table amount.";
        this.error_dialog = true;
        return;
      }
      if (this.storeCommission === "") {
        this.error_text = "Please enter store commission.";
        this.error_dialog = true;
        return;
      }
      if (this.storePeriodTime === "") {
        this.error_text = "Please enter store period table time.";
        this.error_dialog = true;
        return;
      }
      if (this.storeRating < 0 || this.storeRating > 5) {
        this.error_text = "Rating must be between 0 - 5.";
        this.error_dialog = true;
        return;
      }

      this.isUpdating = true;
      let storeImageList = [];
      for (let i = 0; i < this.storeImage.length; i++) {
        if (this.storeImage[i].image_store.includes("data:")) {
          storeImageList.push({ image: this.storeImage[i].image_store });
        }
      }
      var payload = {
        data: {
          store_id: this.store.store_information.store_id,
          store_types: this.storeType,
          store_categories: this.storeCategories,
          delete_image_id: this.removeStoreImage || [],
          store_package: null,
          store_name_th: this.storeNameTH,
          store_name_en: this.storeNameEN,
          store_address_th: this.storeAddressTH,
          store_address_en: this.storeAddressEN,
          store_description_th: this.storeDescriptionTH,
          store_description_en: this.storeDescriptionEN,
          store_recommend: this.storeRecommend,
          store_best_seller: this.storeBestSeller,
          store_district: this.storeDistrict,
          store_sub_district: this.storeSubDistrict,
          store_zipcode: this.storeZipcode,
          store_lat: this.storeLat,
          store_long: this.storeLng,
          store_image: storeImageList || [],
          store_profile: this.storeProfileImage,
          store_province: this.storeProvince,
          store_tel: this.storeTel,
          store_rating: this.store.store_information.store_rating,
          store_email: this.storeEmail,
          store_approve: this.store.store_information.store_approve,
          store_status: this.store.store_information.store_status,
          store_commission: parseFloat(this.storeCommission),
          store_table_amount: parseInt(this.storeTableAmount),
          store_period_table_time: this.storePeriodTime,
          store_rating: this.storeRating,
        },
      };
      var res = await this.$store.dispatch(
        "fetchDineIn/updateDineInStore",
        payload
      );
      this.isUpdating = false;
      if (res === false) {
        this.failed_dialog = true;
      } else {
        await this.$store.dispatch("fetchDineIn/getAllDineInStore", {
          page_size: 999999999,
          current_page: 1,
        });
        this.$emit("closeEditDialog");
      }
    },
    resetData() {
      this.storeType = [];
      this.storeCategories = [];
      this.storeNameTH = "";
      this.storeNameEN = "";
      this.storeAddressTH = "";
      this.storeAddressEN = "";
      this.storeDescriptionTH = "";
      this.storeDescriptionEN = "";
      this.storeTel = "";
      this.storeEmail = "";
      this.storeProvince = "";
      this.storeDistrict = "";
      this.storeSubDistrict = "";
      this.storeZipcode = "";
      this.storeRecommend = 1;
      this.storeBestSeller = 1;
      this.storeImageTemp = "";
      this.error_text = "";
      this.storeProfileImage = "";
      this.storeImage = [];
      this.storeStatus = false;
      this.storeLat = "7.880338324673776";
      this.storeLng = "98.39217356819148";
      this.removeStoreImage = [];
      this.storeTableAmount = "";
      this.storeCommission = "";
    },
    async setData() {
      this.storeType = this.store.store_information.store_types.map(
        (val) => val.store_type_id
      );
      this.storeCategories = this.store.store_information.store_categories.map(
        (val) => val.store_category_id
      );
      this.storePackage = null;
      this.storeNameTH = this.store.store_information.store_name_th;
      this.storeNameEN = this.store.store_information.store_name_en;
      this.storeAddressTH = this.store.store_information.store_address_th;
      this.storeAddressEN = this.store.store_information.store_address_en;
      this.storeDescriptionTH =
        this.store.store_information.store_description_th;
      this.storeDescriptionEN =
        this.store.store_information.store_description_en;
      this.storeTel = this.store.store_information.store_tel;
      this.storeEmail = this.store.store_information.store_email;
      this.storeProvince = this.store.store_information.store_province;
      this.storeDistrict = this.store.store_information.store_district;
      this.storeSubDistrict = this.store.store_information.store_sub_district;
      this.storeZipcode = this.store.store_information.store_zipcode;
      this.storeRecommend = this.store.store_information.store_recommend;
      this.storeBestSeller = this.store.store_information.store_best_seller;
      this.storeImageTemp = "";
      this.storeProfileImage = this.store.store_information.store_image;
      this.storeImage = this.store.collect_image;
      this.storeStatus = this.store.store_information.store_status;
      this.storeLat = this.store.store_information.store_lat;
      this.storeLng = this.store.store_information.store_long;
      this.storeTableAmount = this.store.store_information.store_table_amount;
      this.storeCommission = this.store.store_information.store_commission;
      this.storePeriodTime =
        this.store.store_information.store_period_table_time;
      this.storeRating = this.store.store_information.store_rating;
      this.change++;
      await this.fetchData();
      var provinceName;

      for (let i = 0; i < this.provinceData.length; i++) {
        if (this.provinceData[i].province_id == this.storeProvince) {
          provinceName = this.provinceData[i].province_name_en.toLowerCase();
          this.store_package = await this.$store.dispatch(
            "fetchPackageBack/getPackageByProvince",
            provinceName
          );
        }
      }
      this.district = await this.$store.dispatch(
        "fetchProvinceBack/getDistrictCore",
        this.storeProvince
      );
      this.sub_district = await this.$store.dispatch(
        "fetchProvinceBack/getSubDistrictCore",
        this.storeDistrict
      );
      this.zipcode = await this.$store.dispatch(
        "fetchProvinceBack/getZipCodeCore",
        this.storeDistrict
      );
    },
    selectNewProvince() {
      this.sub_district = [];
      this.storeSubDistrict = "";
      this.zipcode = [];
      this.storeZipcode = "";
    },
    async getDistrict() {
      this.district = [];
      this.storeDistrict = "";
      this.selectNewProvince();
      this.district = await this.$store.dispatch(
        "fetchProvinceBack/getDistrictCore",
        this.storeProvince
      );
    },
    async getStoreData(id) {
      this.store = await this.$store.dispatch(
        "fetchDineIn/getDineInStoreById",
        id
      );
      await this.setData();
      return;
    },
    async getStoreType() {
      this.isLoadingStoreType = true;
      this.store_type = await this.$store.dispatch(
        "fetchDineIn/getDineInStoreType"
      );
      this.isLoadingStoreType = false;
    },
    async getStoreCategory() {
      this.isLoadingStoreCategory = true;
      this.store_category = await this.$store.dispatch(
        "fetchDineIn/fetchStoreCategory"
      );
      this.isLoadingStoreCategory = false;
    },
    deleteStoreImage() {
      if (
        this.storeImage[this.deleteImageIndex].image_store.includes("https:")
      ) {
        this.removeStoreImage.push(
          this.storeImage[this.deleteImageIndex].image_id
        );
      }
      if (this.deleteImageIndex > -1) {
        this.storeImage.splice(this.deleteImageIndex, 1);
      }
      this.deleteImgDialog = false;
      this.deleteImageIndex = 0;
    },
    async getSubDistrict() {
      this.sub_district = await this.$store.dispatch(
        "fetchProvinceBack/getSubDistrictCore",
        this.storeDistrict
      );
    },
    async getZipcode() {
      this.zipcode = await this.$store.dispatch(
        "fetchProvinceBack/getZipCodeCore",
        this.storeDistrict
      );
    },
    async getSubAndZip() {
      await this.getSubDistrict();
      await this.getZipcode();
    },
    async fetchData() {
      await this.$store.dispatch("fetchProvinceBack/getData");
    },
  },
  created() {
    this.getStoreType();
    this.getStoreCategory();
  },
};
</script>
<style scoped>
.info-header {
  margin-right: 10px;
  font-size: 18px;
  font-weight: 600;
}
</style>
